import { createIcon } from '@chakra-ui/react';
import { SVGShapeType, SVGShapes } from '../../../sheet/constants/icons/icons';

export const createCustomIcon = (
  boxSize: number,
  shapes: SVGShapes,
  displayName: string
) =>
  createIcon({
    displayName: displayName,
    viewBox: `0 0 ${boxSize} ${boxSize}`,

    path: shapes.map(
      (
        { type, fillOpposite, x, y, hasStroke, strokeWidth, ...shape },
        index
      ) => {
        const visibleFill = fillOpposite ? 'red' : 'currentColor';
        const stroke = hasStroke ? 'currentColor' : '';
        switch (type) {
          case SVGShapeType.Path:
            return (
              <path
                key={`path${index}`}
                d={shape.d}
                fill={visibleFill}
                strokeLinecap={shape.lineCap}
                strokeLinejoin={shape.lineJoin}
                strokeWidth={strokeWidth}
                stroke={stroke}
                fillRule={shape.fillRule}
              />
            );
          case SVGShapeType.Circle:
            return (
              <circle
                fill={visibleFill}
                key={`circle${index}`}
                cx={x}
                cy={y}
                r={shape.radius}
                stroke={stroke}
                strokeWidth={strokeWidth}
              />
            );
          case SVGShapeType.Ellipse:
            return (
              <ellipse
                fill={visibleFill}
                key={`ellipse${index}`}
                cx={x}
                cy={y}
                rx={shape.radiusX}
                ry={shape.radiusY}
                stroke={stroke}
                strokeWidth={strokeWidth}
              />
            );
          case SVGShapeType.Rectangle:
            return (
              <rect
                fill={visibleFill}
                key={`rectangle${index}`}
                x={x}
                y={y}
                width={shape.width}
                height={shape.height}
                stroke={stroke}
                strokeWidth={strokeWidth}
                rx={shape.cornerRadius}
              />
            );
        }
        return <></>;
      }
    ),
  });
